var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewCampaignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4165 13.3333C17.0273 13.3333 18.3332 10.9082 18.3332 7.91667C18.3332 4.92512 17.0273 2.5 15.4165 2.5M15.4165 13.3333C13.8057 13.3333 12.4998 10.9082 12.4998 7.91667C12.4998 4.92512 13.8057 2.5 15.4165 2.5M15.4165 13.3333L4.53612 11.3551C3.76321 11.2146 3.37676 11.1443 3.06427 10.9908C2.42856 10.6785 1.95514 10.1113 1.76162 9.42994C1.6665 9.09504 1.6665 8.70225 1.6665 7.91667C1.6665 7.13108 1.6665 6.73829 1.76162 6.40339C1.95514 5.72207 2.42856 5.15481 3.06427 4.84254C3.37676 4.68904 3.76321 4.61878 4.53612 4.47825L15.4165 2.5M4.1665 11.6667L4.49472 16.2617C4.52589 16.698 4.54147 16.9162 4.6364 17.0816C4.71998 17.2272 4.84558 17.3441 4.99675 17.4171C5.16844 17.5 5.38718 17.5 5.82466 17.5H7.31C7.81012 17.5 8.06018 17.5 8.24526 17.4003C8.40789 17.3126 8.53679 17.1734 8.61169 17.0046C8.69694 16.8124 8.67776 16.5631 8.63941 16.0644L8.33317 12.0833",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCampaignIcon);
export default __webpack_public_path__ + "static/media/new_campaign_icon.08ab6c1047cff6882fa4a2029b262c4c.svg";
export { ForwardRef as ReactComponent };